import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "homeView" }
const _hoisted_2 = { class: "searchBar" }

import { listAppVoByPageUsingPost } from "@/api/appController";
import AppCard from "@/components/AppCard.vue";
import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { REVIEW_STATUS_ENUM } from "@/constant/app";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const formSearchParams = ref<API.AppQueryRequest>({});
// 初始化搜索条件（不被修改）
const initSearchParams = {
  current: 1,
  pageSize: 12,
};

const searchParams = ref<API.AppQueryRequest>({
  ...initSearchParams,
});

const dataList = ref<API.AppVO[]>([]);
const total = ref<number>(0);

// 加载数据
const loadData = async () => {
  const params = {
    reviewStatus: REVIEW_STATUS_ENUM.PASS, // 只展示审核通过的应用
    ...searchParams.value,
  };
  const res = await listAppVoByPageUsingPost(params);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 当页数变化时，改变搜索条件，为后续触发加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 执行搜索
 */
const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    ...formSearchParams.value,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        size: "large",
        "allow-clear": "",
        modelValue: formSearchParams.value.appName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSearchParams.value.appName) = $event)),
        style: { width: '320px' },
        placeholder: "发现答题应用",
        "search-button": "",
        onChange: doSearch
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_a_list, {
      "grid-props": { gutter: [20, 20], sm: 24, md: 12, lg: 8, xl: 6 },
      class: "list-demo-action-layout",
      bordered: false,
      data: dataList.value,
      "pagination-props": {
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(AppCard, { app: item }, null, 8, ["app"])
      ]),
      _: 1
    }, 8, ["data", "pagination-props"])
  ]))
}
}

})